import { render, staticRenderFns } from "./contentControl.vue?vue&type=template&id=2d7a5136&scoped=true&"
import script from "./contentControl.vue?vue&type=script&lang=js&"
export * from "./contentControl.vue?vue&type=script&lang=js&"
import style0 from "./contentControl.vue?vue&type=style&index=0&id=2d7a5136&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a5136",
  null
  
)

export default component.exports